<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Visitor Log</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->
  <div #peopleContainer class="card-body" style="">
    <div class="participant-list" style="">
      <div>
        <ul>
          <ng-container *ngFor="let activeUser of activeUsers">
            <li *ngIf="activeUser.connected">
              <div class="d-flex align-items-center pb-3">
                <div class="mr-auto">
                  <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + activeUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ activeUser.id }}-avatar.png"  />
                  <span class="participant-name ml-2">{{ activeUser.firstName }} {{ activeUser.lastName }} </span>
                </div>

                <!-- <span *ngIf="user.id == activeUser.id" class="participant-menu">
                  <strong>This is you</strong>
                </span> -->
              </div>
            </li>
            <li *ngIf="!activeUser.connected && !active">
              <div class="d-flex align-items-center pb-3">
                <div class="mr-auto">
                  <img class="avatar u-sm-avatar rounded-circle"[fallback]="'fetch-avatar?userId=' + activeUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ activeUser.id }}-avatar.png"  />
                  <span class="participant-name ml-2">{{ activeUser.firstName }} {{ activeUser.lastName }} </span>
                </div>

                <!-- <span *ngIf="user.id == activeUser.id" class="participant-menu">
                  <strong>This is you</strong>
                </span> -->
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
  <!-- End Body -->

  <!-- End Footer -->
</div>
